import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-array',
  templateUrl: './app-array.component.html',
})
export class AppArrayComponent extends FieldComponent {

}
